import{createContext as t}from"react";const o=/*#__PURE__*/t({});export default o;